export const MIXPANEL = 'mixpanel'
